export interface IDropdownModel {
	id: any;
	text: string;
	customField?: string;
	// slick-drop-down draws a separator line above this item
	dividerBefore?: boolean;
}

export class DropdownModel implements IDropdownModel {
	constructor(id: any, text: string, customField = null) {
		this.id = id;
		this.text = text;
		this.customField = customField;
	}

	id: any;
	text: string;
	customField?: string;
}